<template>
    <el-dialog 
        :visible.sync="openStatus"
        :title="$t('slb.text.editDomain')"
        :close-on-click-modal="false" @close="doClose">
        <el-table :data="[currentDomain]" class="mt20 mb40">
            <!--域名-->
            <el-table-column 
                :label="$t('slb.text.domain')"
                key="domain"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.domain | maybeEmpty}}</span>
                </template>
            </el-table-column>
            <!--证书-->
            <el-table-column 
                :label="$t('slb.text.certificate')"
                key="certificate">
                <template slot-scope="scope">
                    <el-select 
                        v-model="scope.row.certificateId">
                        <el-option 
                            v-for="item in certificates" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>  
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="doClose">{{ $t('listPage.text.cancelButton') }}</el-button>
            <el-button type="primary" @click="doConfirm">
                {{ $t('listPage.text.sureButton') }}
            </el-button>
        </span>
    </el-dialog>
</template>


<script>

export default {
    data() {
        return {
            openStatus: this.dialogVisible,
            certificates: []
        };
    },
    computed: {
     
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: true,
        },
        currentDomain: {
            type: Object,
        },
        region: {
            type: String,
        },
        listenerId: {
            type: String
        }
    },
    watch: {
        dialogVisible(val) {
            this.openStatus = val;
        },
    },
    mounted() {
        this.getSlbCertListData();
    },
    methods: {
        // 关闭弹框
        doClose() {
            // this.$emit('closeModifyDomainDialog', false);
            this.$emit('update:dialogVisible', false);
        },
        // 点击确认按钮,编辑扩展域名
        doConfirm() {
            this.editDomain();
        },

        /**
            **@disc: 获取负载均衡证书数据
            **@params: none
        */
        getSlbCertListData() {
            this.refreshLoading = true;
            const param = {
                region: this.region,
            };
            Ajax.get('/api/cps/queryCertificatePage', param)
            .then((res) => {
                this.refreshLoading = false;
                this.certificates = res.data.certs.map(item => {
                    return {
                        value: item.certId,
                        label: item.name
                    }
                });
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.refreshLoading = false;
            })
        },

        editDomain() {
            const params = {
                certificateId: this.currentDomain.certificateId,
                domain: this.currentDomain.domain,
                sniId: this.currentDomain.sniId,
                listenerId: this.listenerId,
                region: this.region
            };
            Ajax.post('/api/cps/listenerSni', params, {
                headers: {
                  'Content-Type': 'application/json'
                }
            })
            .then((res) => {
                if (res.data && res.data.success) {
                    this.$message.success(this.$t('subnet.text.operationSuccess'));
                    this.$emit('modifyComplete')
                }
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            }).finally( () => {
                this.doClose();
            });
        }
    }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/slb/modifyDomain/ModifyDomain.vue